import { render, staticRenderFns } from "./CineplexxWidget.vue?vue&type=template&id=906eea0e&"
import script from "./CineplexxWidget.vue?vue&type=script&lang=ts&"
export * from "./CineplexxWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CineplexxWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports